import { ClientType } from "src/api/v1/project-ApiSlice";
import { Fragment, useEffect, useState } from "react";
import { Product } from "src/pages/OfferPage/FunctionDescription/Category/SubCategory/Products/Product/Product";

export const Products = (props: { products: any, clientType: ClientType}) => {
  const { products, clientType } = props;

  const [hasDescription, setHasDescription] = useState(false);

  useEffect(() => {
    if (products && Object.keys(products).length) {
      Object.keys(products).map((product) => {
        if (
            products[product].descriptions[clientType].desc &&
            products[product].descriptions[clientType].desc.trim() !== "<p><br></p>"
        ) {
          setHasDescription(true);
        }
      });
    }
  }, [products, clientType]);

  return hasDescription ? (
      <Fragment>
        {Object.keys(products).map((product, key) => (
            <Product
                productKey={key}
                product={products[product]}
                clientType={clientType}
            />
        ))}
      </Fragment>
  ) : null;
};
